import {LocalDate} from 'js-joda'
import * as PrismaManufacturerStatus from '../../../Entities/PrismaManufacturerStatus'
import {BpsUser} from '../../../Entities/BpsUser'
import * as PrismaRequestFilterType from './PrismaRequestFilterType'

export type M =
    | BpsUserFilterInput
    | CreatedFromFilterInput
    | CreatedToFilterInput
    | StatusFilterInput

interface BpsUserFilterInput {
    readonly type: 'BpsUserFilterInput'
    readonly bpsUserSearch: string
    readonly bpsUserSuggestions: BpsUser[]
    readonly selectedBpsUser: BpsUser | null
}

interface CreatedFromFilterInput {
    readonly type: 'CreatedFromFilterInput'
    readonly value: LocalDate | null
}

interface CreatedToFilterInput {
    readonly type: 'CreatedToFilterInput'
    readonly value: LocalDate | null
}

interface StatusFilterInput {
    readonly type: 'StatusFilterInput'
    readonly value: PrismaManufacturerStatus.M | null
}

export function fromFilterType(filterType: PrismaRequestFilterType.M): M {
    switch (filterType) {
        case 'BpsUser':
            return {
                type: 'BpsUserFilterInput',
                bpsUserSearch: '',
                bpsUserSuggestions: [],
                selectedBpsUser: null,
            }
        case 'CreatedFrom':
            return {
                type: 'CreatedFromFilterInput',
                value: null
            }
        case 'CreatedTo':
            return {
                type: 'CreatedToFilterInput',
                value: null
            }
        case 'Status':
            return {
                type: 'StatusFilterInput',
                value: null
            }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/PrismaRequestFiltering/Model/PrismaRequestFilterInput.ts